import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';
import { InfoOutlineIcon } from '@app-velocity/icons';
import { Tooltip } from '@app-velocity/ui';

const StyledIndicator = styled('div')(({ theme }) => ({
  color: 'var(--icon-icon-secondary-color)',
  svg: {
    fill: 'var(--icon-icon-secondary-color)'
  },
}));

export const ResultsTooltip = () => {
  const { t } = useI18n();

  return (
    <Tooltip title={t('shared:results_footer.tooltip')}>
      <StyledIndicator>
        <InfoOutlineIcon />
      </StyledIndicator>
    </Tooltip>)
};